'use client';
import { YM_SOURCE } from './domain.js';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */ function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Инициализация скрипта:
 * https://yandex.ru/support/metrica/code/counter-initialize.html
 * */ var initializeYM = function(config) {
    var _containerElement_parentNode;
    var _config_scriptSource = config.scriptSource, scriptSource = _config_scriptSource === void 0 ? YM_SOURCE : _config_scriptSource, _config_key = config.key, key = _config_key === void 0 ? "ym" : _config_key, _config_scriptTag = config.scriptTag, scriptTag = _config_scriptTag === void 0 ? "script" : _config_scriptTag, counterId = config.counterId, _config_options = config.options, options = _config_options === void 0 ? {} : _config_options;
    window[key] = window[key] || function() {
        (window[key].a = window[key].a || []).push(arguments);
    };
    window[key].l = 1 * new Date();
    var scriptElement = document.createElement(scriptTag);
    var containerElement = document.getElementsByTagName(scriptTag)[0];
    scriptElement.async = true;
    scriptElement.src = scriptSource;
    containerElement == null ? void 0 : (_containerElement_parentNode = containerElement.parentNode) == null ? void 0 : _containerElement_parentNode.insertBefore(scriptElement, containerElement);
    if (!counterId) {
        throw new Error('Для плагина аналитики "YM" не задан counterId!');
    }
    window[key](counterId, "init", _extends({
        accurateTrackBounce: true,
        clickmap: true,
        ecommerce: "dataLayer",
        trackLinks: true
    }, options, {
        /**
         * Не предоставляем возможность переопределить данный флаг.
         * https://yandex.ru/support/metrica/code/counter-initialize.html#counter-initialize__check-initialize
         * */ triggerEvent: true
    }));
};

export { initializeYM };
